import { useRecruitingInterview } from '../../../hooks/useRecruitingInterview';
import { selectRecruitingInterviewStep } from '../../../store/exam/selectors';
import { setRecruitingInterviewStep } from '../../../store/exam/slice';
import { useDispatch, useSelector } from '../../../store/store';
import CollectingData from '../../../containers/CollectingData';
import { useLocation, useNavigate } from 'react-router-dom';
import InterviewEnd from './containers/InterviewEnd';
import PreInterview from './containers/PreInterview';
import ExamLayout from '../../../layouts/Exam';
import Interview from './containers/Interview';
import KYC from '../../../containers/KYC';
import { useEffect } from 'react';

export default function RecruitingInterview() {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const step = useSelector(selectRecruitingInterviewStep);

    const {
        jobId,
        userId,
        action,
        profile,
        counter,
        webcamRef,
        nextQuestion,
        interviewData,
        startInterview,
        totalQuestions,
        isFetchingData,
        currentQuestion,
        fileUploadProgress,
    } = useRecruitingInterview();

    useEffect(() => {
        if (!location?.state?.jobId) {
            navigate('/workspace');
        }

        return () => {
            dispatch(setRecruitingInterviewStep('KYC'));
        }
    }, []);

    return (
        <ExamLayout headerTitle='Recruiting Interview'>

            {step === 'KYC' && <KYC
                jobId={jobId}
                userId={userId}
                examId='interview'
                profile={profile}
                onSuccess={() => dispatch(setRecruitingInterviewStep('PreInterview'))}
            />}

            {step === 'PreInterview' && <PreInterview
                jobId={jobId}
                action={action}
                startInterview={startInterview}
                isFetchingData={isFetchingData}
            />}

            {step === 'Interview' && <Interview
                counter={counter}
                webcamRef={webcamRef}
                nextQuestion={nextQuestion}
                interviewData={interviewData}
                totalQuestions={totalQuestions}
                isFetchingData={isFetchingData}
                currentQuestion={currentQuestion}
            />}

            {step === 'CollectingData' &&
                <CollectingData
                    progress={fileUploadProgress}
                    description='Please remain on this page while we collect your interview data.'
                />}

            {step === 'InterviewEnd' && <InterviewEnd />}
        </ExamLayout>
    )
};
